let slickDefaults = require('./mini-slider.less');

jQuery(function() {
    $('.js-mini-slider').each(function() {
        var $this = $(this);

        $this.slick(
            $.extend({}, slickDefaults.params, {
                slidesToShow: 1
            })
        );
    });
});



// WEBPACK FOOTER //
// ./blocks/mini-slider/mini-slider.js